import {
  useStyle 
} from "@/classify"
import {
  usePassword 
} from "@/hooks/Password/usePassword"
import {
  Eye, EyeOff 
} from "react-feather"
import {
  isRequired 
} from "../../util/formValidators"
import Button from "../Button"
import Field from "../Field"
import TextInput from "../TextInput"
import defaultClasses from "./password.module.css"

const Password = (props) => {
  const {
    classes: propClasses,
    label,
    fieldName,
    isToggleButtonHidden = true,
    autoComplete,
    validate = isRequired,
    required = true,
    ...otherProps
  } = props

  const talonProps = usePassword()
  const {
    handleBlur, togglePasswordVisibility, visible 
  } = talonProps
  const classes = useStyle(defaultClasses, propClasses)

  const passwordButton = (
    <Button
      className={classes.passwordButton}
      onClick={togglePasswordVisibility}
      type='button'
    >
      {visible ? <Eye /> : <EyeOff />}
    </Button>
  )

  const fieldType = visible ? "text" : "password"

  return (
    <Field
      id='Password'
      label={label}
      classes={{
        root: classes.root 
      }}
      required={required}
    >
      <TextInput
        after={!isToggleButtonHidden && passwordButton}
        autoComplete={autoComplete}
        field={fieldName}
        type={fieldType}
        validate={validate}
        onBlur={handleBlur}
        {...otherProps}
      />
    </Field>
  )
}

export default Password
